import InsurancePage from "./InsurancePage";

export default InsurancePage;

export * from "./InsurancePage";
